import React from 'react';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Button, UpgradeButton } from '@playbookux/playbook-web-core';
import {
  Bold,
  Container,
  Content,
  Header,
  SquareContainer,
  SquareContent,
  SubHeader,
  UpgradeContainer,
} from './styles';
import FieldToCopy from '../../../../../components/field-to-copy';
import { config } from '../../../../../../config';
import { Link } from '../styles';

const INFO_LINK = 'https://help.playbookux.com/en/articles/4430929-moderated-interview-faqs';

const STEPS_LINK = 'https://help.playbookux.com/en/articles/'
  + '5992427-granting-screen-share-audio-and-video-permissions-before-a-moderated-session';

const MeetingModal = (props) => {
  const {
    values,
    isOpen,
    onClose,
    hiddenObserver: {
      featureFlag,
      onUpdate,
    },
  } = props;

  const hiddenObserverUrl = values?.testSessionId && `${config.REACT_APP_COMPANY_PLATFORM_URI}/livestream/${values?.testSessionId}`;

  const redirectToMeeting = (url) => {
    if (!url) return;

    window.open(url);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <Container>
        <Header>
          <Bold>
            Meeting links for your session with
            {' '}
            {values?.name}
          </Bold>
          Date & time:
          {' '}
          {values?.startAt}
        </Header>
        {values?.isJoin && (
          <SubHeader>
            A few details before your session:
            <br />
            - Review testing policies and FAQs
            {' '}
            <a href={INFO_LINK} target="_blank" rel="noopener noreferrer">here</a>
            <br />
            - The meeting will not begin until someone joins as a moderator
            <br />
          </SubHeader>
        )}
        <Content>
          <SquareContainer>
            <Bold>Join as a moderator</Bold>
            <SquareContent>
              - Chat with participants
              <br />
              - Take live notes (web browser only)
              <br />
              - If this is your first time testing with us,
              <br />
              please take a moment to
              {' '}
              <a href={STEPS_LINK} target="_blank" rel="noopener noreferrer">grant permissions</a>
            </SquareContent>
            {values?.isJoin ? (
              <>
                <SquareContent center>
                  <Button onClick={() => redirectToMeeting(values?.meetingUrl)}>Join meeting from your browser</Button>
                </SquareContent>
                <SquareContent center>
                  {values?.startUrl && (
                    <Link href={values?.startUrl} onClick={onClose} target="_blank" rel="noopener noreferrer">
                      Join from the computer app
                    </Link>
                  )}
                </SquareContent>
              </>
            ) : (
              <>
                <SquareContent>
                  <Bold className="low">Web browser</Bold>
                  <FieldToCopy value={values?.meetingUrl} />
                </SquareContent>
                <SquareContent>
                  <Bold className="low">Desktop app</Bold>
                  <FieldToCopy value={values?.startUrl} />
                </SquareContent>
              </>
            )}
          </SquareContainer>
          <SquareContainer>
            <Bold>Join as an observer</Bold>
            <SquareContent>
              - You will not be visible to participants and moderators
            </SquareContent>
            {hiddenObserverUrl && featureFlag ? (
              <>
                {values?.isJoin
                  ? (
                    <SquareContent center top={45}>
                      <Button onClick={() => redirectToMeeting(hiddenObserverUrl)}>Join meeting from your browser</Button>
                    </SquareContent>
                  )
                  : (
                    <SquareContent top={45}>
                      <Bold className="low">Web browser</Bold>
                      <FieldToCopy value={hiddenObserverUrl} />
                    </SquareContent>
                  )}
              </>
            ) : (
              <UpgradeContainer>
                <UpgradeButton
                  onClick={onUpdate}
                  pointer
                  noMargin
                >
                  Upgrade
                </UpgradeButton>
              </UpgradeContainer>
            )}
          </SquareContainer>
        </Content>
      </Container>
    </Modal>
  );
};

MeetingModal.defaultProps = {
  isOpen: false,
  values: null,
  hiddenObserver: {
    featureFlag: false,
    onUpdate: () => {},
  },
};

MeetingModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string,
    startAt: PropTypes.string,
    testSessionId: PropTypes.string,
    meetingUrl: PropTypes.string,
    startUrl: PropTypes.string,
    isJoin: PropTypes.bool,
  }),
  hiddenObserver: PropTypes.shape({
    featureFlag: PropTypes.bool,
    onUpdate: PropTypes.func,
  }),
};

export default MeetingModal;
